import { ref } from 'vue';
import ApiService from '../services/api.service';
import { stringifyQueryObject } from '@/helpers/stringifyQueryObject';
import { useRoute, useRouter } from 'vue-router';

const preparePayload = (queriesObj) => {
  const payload = {};

  if (queriesObj.search) {
    payload.q = queriesObj.search; // Map 'search' to 'q' if it has value
  }

  if (queriesObj.sort !== null && queriesObj.sort !== undefined) {
    payload.s = queriesObj.sort; // Map 'sort' to 's' if it has value
  }

  if (queriesObj.user_id) {
    payload.u = queriesObj.user_id; // Map 'user_id' to 'u' if it has value
  }
  if (queriesObj.tag_id) {
    payload.tag_id = queriesObj.tag_id;
  }

  return payload;
};
const queries = ref({
  search: '',
  tag_id: '',
  sort: '',
  status: [],
  user_id: ''
});
const originalPayload = ref('');
export default function useTaskStatus() {
  const isTaskLisLoading = ref(true);
  const route = useRoute();
  const router = useRouter();
  const deletedStatusId = ref(null);
  const taskStatuses = ref([]);
  const taskStatusesListOpt = ref([]);
  const originalTaskStatuses = ref([]);

  const addFilterQueriesToRoute = async () => {
    if (typeof queries.value.tag_id !== 'string' && queries?.value?.tag_id?.value) queries.value.tag_id = queries?.value?.tag_id?.value;
    if (typeof queries.value.sort !== 'string' && queries?.value?.sort?.value) queries.value.sort = queries?.value?.sort?.value;
    router.replace(route.path + stringifyQueryObject(queries.value));
  };
  const getTaskStatus = async (id = true, isNeedLoading = false) => {
    try {
      if (isNeedLoading) isTaskLisLoading.value = true;
      let path = '/project/' + id + '/task_tatus';
      if (typeof queries.value.tag_id !== 'string' && queries?.value?.tag_id?.value) queries.value.tag_id = queries?.value?.tag_id?.value;
      let payload = preparePayload(queries.value);

      if (originalPayload.value !== path) {
        path += '?' + new URLSearchParams(payload);

        const response = await ApiService.get(path).finally(() => {
          isTaskLisLoading.value = false;
        });
        originalPayload.value = path;
        originalTaskStatuses.value = response.data.data;
        addFilterQueriesToRoute();
        taskStatusesListOpt.value = response.data.data.map((taskStatus) => ({
          value: taskStatus.id,
          label: taskStatus.title
        }));
        taskStatuses.value = response.data.data;

        if (queries.value?.status?.length) {
          updateItemsAppearing();
        }
      }
    } catch (error) {}
  };

  const changeStatusOfTask = async (taskID, statusID, id, statusIndex, isNeedToBeSorted) => {
    try {
      const response = await ApiService.put('/task/' + taskID + '/status-update', {
        task_status_id: statusID
      });
      if (isNeedToBeSorted) await changeSortTasks(id, statusIndex);
    } catch (error) {
      await getTaskStatus(id);
    } finally {
      await getTaskStatus(id);
    }
  };
  const updateItemsAppearing = () => {
    if (queries?.value?.status?.length === 0) {
      taskStatuses.value = originalTaskStatuses.value;
    } else
      taskStatuses.value = originalTaskStatuses.value.filter((taskStatus) => {
        if (queries?.value?.status?.length && queries?.value?.status?.includes(taskStatus?.id)) {
          return taskStatus;
        }
      });
  };
  const changeOrderStatus = async (id) => {
    try {
      const ids = taskStatuses.value.map((item) => item?.id);
      const response = await ApiService.get('/task_status/' + id + '/sort-update/' + ids);
      // AlertService.successMessage(response.data.message);
    } catch (error) {
      await getTaskStatus(id);
    }
  };
  const changeSortTasks = async (id, statusIndex) => {
    try {
      if (taskStatuses?.value && taskStatuses?.value[statusIndex]?.tasks?.length) {
        const ids = taskStatuses?.value[statusIndex]?.tasks?.map((item) => item?.id);
        let statusId = taskStatuses?.value[statusIndex]?.id;
        const response = await ApiService.get('/task/status/' + statusId + '/sort-update/' + ids);
      }
      // AlertService.successMessage(response.data.message);
    } catch (error) {
      await getTaskStatus(id);
    }
  };

  const storeStatus = async (data, project_id) => {
    try {
      const response = await ApiService.post('/task_status', data);
      if (response.status === 201) {
        await getTaskStatus(project_id);

        // AlertService.successMessage(response.data.message);
      }
    } catch (error) {}
  };
  const addSingleTask = async (data, id) => {
    try {
      let isSuccess = false;
      const response = await ApiService.post('/task', data);
      if (response.status === 201) {
        isSuccess = true;
        await getTaskStatus(id);
        // AlertService.successMessage(response.data.message);
        return isSuccess;
      }
    } catch (error) {}
  };

  const UpdateSingleTask = async (task_id, project_id, data) => {
    try {
      let isSuccess = false;
      const response = await ApiService.post('/task/' + task_id, data);
      if (response.status === 200) {
        isSuccess = true;
        await getTaskStatus(project_id);
        return isSuccess;
        // AlertService.successMessage(response.data.message);
      }
    } catch (error) {}
  };

  const deleteSingleTask = async (task_id, _project_id) => {
    try {
      const response = await ApiService.delete('/task/' + task_id);
      if (response.status === 200) {
        // AlertService.successMessage(response.data.message);
        await getTaskStatus(_project_id);
      }
    } catch (error) {}
  };

  const showSingleTaskDetail = async (id) => {
    try {
      return await ApiService.get('/task/' + id);
    } catch (error) {
      return [];
    }
  };

  const updateStatus = async (id, data, project_id) => {
    try {
      const response = await ApiService.put('/task_status/' + id, data);
      if (response.status === 200) {
        // AlertService.successMessage(response.data.message);
        await getTaskStatus(project_id);
      }
    } catch (error) {}
  };

  const destroyStatus = async (id, project_id) => {
    try {
      const response = await ApiService.delete('/task_status/' + id);
      if (response.status === 200) {
        // AlertService.successMessage(response.data.message);
        deletedStatusId.value = id;
        await getTaskStatus(project_id);
      }
    } catch (error) {}
  };

  const addComment = async (data) => {
    return await ApiService.post('/comments', data);
  };
  const deleteComment = async (id) => {
    return await ApiService.delete('/comments/' + id);
  };
  const editComment = async (id, comment) => {
    return ApiService.put('/comments/' + id, { comment });
  };

  return {
    deleteComment,
    deletedStatusId,
    originalPayload,
    taskStatuses,
    changeStatusOfTask,
    getTaskStatus,
    changeOrderStatus,
    storeStatus,
    updateStatus,
    taskStatusesListOpt,
    updateItemsAppearing,
    destroyStatus,
    changeSortTasks,
    isTaskLisLoading,
    queries,
    editComment,
    addSingleTask,
    showSingleTaskDetail,
    addComment,
    deleteSingleTask,
    UpdateSingleTask
  };
}
